import { ConfigCatProvider } from './ConfigCatProvider';
import { FloraProvider } from './FloraProvider';
import { ReactQueryProvider } from './ReactQueryProvider';
import { ReactRouterProvider } from './ReactRouterProvider';
import { ProviderStore } from './StoreProvider';

export const providers = [
  ReactQueryProvider,
  ConfigCatProvider,
  FloraProvider,
  ReactRouterProvider,
  ProviderStore,
];

export { FloraProvider };
